const hasAllowedCharactersUsername = (value: string) => /^[@_.A-Za-z0-9-]*$/.test(value);

export default hasAllowedCharactersUsername;
